import React, { useCallback, useEffect, useState, useRef } from 'react';
const PRODUCT = {
  title: 'The Golden Root Ritual',
  edition: 'Digital Guide',
  price: '$17',
  thumbnail: 'https://cdn.magicpatterns.com/uploads/sqWj2RGF8QLq23vTiDj7BE/heylloyd-image-1771222482108.png'
};
const NAMES = ['Sarah', 'Jennifer', 'Patricia', 'Linda', 'Barbara', 'Elizabeth', 'Susan', 'Jessica', 'Karen', 'Nancy', 'Lisa', 'Margaret', 'Betty', 'Sandra', 'Ashley', 'Dorothy', 'Kimberly', 'Emily', 'Donna', 'Michelle', 'Carol', 'Amanda', 'Melissa', 'Deborah', 'Stephanie', 'Rebecca', 'Sharon', 'Laura', 'Cynthia', 'Kathleen', 'Amy', 'Angela', 'Shirley', 'Anna', 'Brenda', 'Pamela', 'Emma', 'Nicole', 'Helen', 'Samantha', 'Katherine', 'Christine', 'Debra', 'Rachel', 'Carolyn', 'Janet', 'Catherine', 'Maria', 'Heather', 'Diane', 'Ruth', 'Julie', 'Olivia', 'Joyce', 'Virginia', 'Victoria', 'Kelly', 'Lauren', 'Christina', 'Joan'];
const CITIES = ['Miami, FL', 'Austin, TX', 'Denver, CO', 'Phoenix, AZ', 'Nashville, TN', 'Charlotte, NC', 'San Diego, CA', 'Portland, OR', 'Tampa, FL', 'Raleigh, NC', 'Scottsdale, AZ', 'Boise, ID', 'Savannah, GA', 'Charleston, SC', 'Dallas, TX', 'Atlanta, GA', 'Orlando, FL', 'Houston, TX', 'Seattle, WA', 'Minneapolis, MN', 'Salt Lake City, UT', 'Richmond, VA', 'Omaha, NE', 'Tulsa, OK', 'Knoxville, TN', 'Lexington, KY', 'Albuquerque, NM', 'Sacramento, CA', 'St. Louis, MO', 'Columbus, OH'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomInterval() {
  return 8000 + Math.random() * 7000; // 8–15 seconds
}
export function RecentPurchaseToast() {
  const [toast, setToast] = useState<{
    name: string;
    city: string;
    visible: boolean;
  } | null>(null);
  const recentNames = useRef<string[]>([]);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hideTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const prefersReducedMotion = useRef(false);
  useEffect(() => {
    prefersReducedMotion.current = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }, []);
  const pickName = useCallback(() => {
    const available = NAMES.filter(n => !recentNames.current.includes(n));
    const pool = available.length > 0 ? available : NAMES;
    const name = getRandomItem(pool);
    recentNames.current = [...recentNames.current.slice(-9), name];
    return name;
  }, []);
  const showToast = useCallback(() => {
    const name = pickName();
    const city = getRandomItem(CITIES);
    setToast({
      name,
      city,
      visible: true
    });
    hideTimeoutRef.current = setTimeout(() => {
      setToast(prev => prev ? {
        ...prev,
        visible: false
      } : null);
      setTimeout(() => {
        setToast(null);
        timeoutRef.current = setTimeout(showToast, getRandomInterval());
      }, prefersReducedMotion.current ? 50 : 400);
    }, 4000);
  }, [pickName]);
  useEffect(() => {
    timeoutRef.current = setTimeout(showToast, 3000);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    };
  }, [showToast]);
  if (!toast) return null;
  const animationClass = prefersReducedMotion.current ? toast.visible ? 'opacity-100' : 'opacity-0' : toast.visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0';
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-sm pointer-events-none" data-id="element-22">
      <div className={`
          pointer-events-auto
          bg-white rounded-xl shadow-lg border border-stone-200
          flex items-center gap-3 p-3
          transition-all duration-400 ease-out
          ${animationClass}
        `} style={{
      transitionDuration: prefersReducedMotion.current ? '0ms' : '400ms'
    }} data-id="element-23">
        {/* Thumbnail */}
        <div className="flex-shrink-0 w-14 h-14 rounded-lg overflow-hidden bg-amber-50" data-id="element-24">
          <img src={PRODUCT.thumbnail} alt={PRODUCT.title} className="w-full h-full object-cover" data-id="element-25" />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0" data-id="element-26">
          <p className="text-sm text-stone-800 leading-snug" data-id="element-27">
            <span className="font-semibold" data-id="element-28">{toast.name}</span> in {toast.city}
          </p>
          <p className="text-xs text-stone-500 mt-0.5" data-id="element-29">
            just purchased{' '}
            <span className="font-medium text-stone-700" data-id="element-30">
              {PRODUCT.edition}
            </span>
          </p>
          <p className="text-xs font-bold text-amber-600 mt-0.5" data-id="element-31">
            {PRODUCT.price}
          </p>
        </div>

        {/* Time indicator */}
        <div className="flex-shrink-0 text-xs text-stone-400 self-start mt-0.5" data-id="element-32">
          just now
        </div>
      </div>
    </div>;
}